var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer, } from 'mobx-react';
import history from 'helpers/History';
import { Table } from 'components';
import { loading } from 'elements/Loading';
var StretchesTable = /** @class */ (function (_super) {
    __extends(StretchesTable, _super);
    function StretchesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filter = [
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
            {
                name: 'all',
                filter: function (item) { return true; }
            }
        ];
        _this.handleSelectItem = function (value) {
            history.push("/stretches/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push("/stretches/create");
        };
        _this.mapea = function (stretches, operationLines) {
            return stretches.map(function (item) {
                var operationLine = operationLines.filter(function (ol) {
                    return ol.id === item.operationLine_id;
                })[0];
                var operationLineString = 'operationLine';
                item[operationLineString] = operationLine ? operationLine.name : '';
                // console.log('item', item)
                item.headboard = item.headboard ? item.headboard.name : '';
                return item;
            });
        };
        return _this;
    }
    StretchesTable.prototype.componentDidMount = function () {
    };
    StretchesTable.prototype.render = function () {
        var stretches = this.props.store.stretches;
        var operationLines = this.props.store.operationLines;
        var headers = /*this.props.store!.UI.isDesktop*/ 
        /*?*/ ['operationLine', 'name', 'origin', 'destination', 'disabled_at', 'headboard', 'emails', 'description'];
        /*: ['name', 'code', 'origin', 'destination', 'operationLine_id', 'description']*/
        var mapeados = this.mapea(stretches.data, operationLines.data);
        // console.log('mapeados', mapeados)
        if (!(operationLines.data.length > 0))
            return React.createElement("div", null,
                React.createElement("text", null, "No hay lineas de operaci\u00F3n, por favor cree una antes"),
                " ");
        // compruebo si hay experiencias sin marketing
        // para preguntar si desea que se le ponga los valores por defecto
        // console.log('StretechesTable - stretches: ', this.props.store.stretches.data)
        var own_ids = [];
        if (this.props.store.stretches.data) {
            for (var _i = 0, _a = this.props.store.stretches.data; _i < _a.length; _i++) {
                var stretch = _a[_i];
                if (!stretch.marketing) {
                    own_ids.push(stretch.id);
                }
            }
            /*console.log('own_ids: ', own_ids)
            if (own_ids.length > 0) {
              const accept = confirm('Esta experiencia no tiene valores para etiquetas de marketing, ¿desea porner por defecto?')
              if (accept) {
                this.props.store.marketingStore.createDefault({data: {owner_ids: [...own_ids]}}).then(result => {
                  StretchesTable.continue = true
                  return history.push(`/stretches`)
                }).catch(error => {
                  console.log('catch error: ', error)
                  StretchesTable.continue = true
                  return history.push(`/stretches`)
                })
                return <div>
                  poniendo por defecto.....
                </div>
              }
            }*/
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Table, { items: mapeados, header: headers, filters: this.filter, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); }, loading: !stretches.loaded, tooltips: true })));
    };
    StretchesTable.continue = false;
    StretchesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.stretches.read(),
                props.store.operationLines.read()
            ];
        }),
        observer
    ], StretchesTable);
    return StretchesTable;
}(Component));
export default StretchesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesTable.tsx
// module id = 1274
// module chunks = 0